import React from "react";
import { Link } from "react-router-dom";
import {
  getNotificationBody,
  getNotificationRoute,
  getNotificationTitle,
  getNotificationTypeLabel,
} from "utils/notificationDisplay";

const AdminNotificationsColumn = [
  {
    Header: "العنوان",
    accessor: "title",
    Cell: ({ row }) => {
      const route = getNotificationRoute(row.original);
      return (
        <Link
          to={route}
          className="text-sm font-semibold text-navy-700 hover:text-blueSecondary hover:underline dark:text-white"
        >
          {getNotificationTitle(row.original)}
        </Link>
      );
    },
  },
  {
    Header: "المحتوى",
    accessor: "body",
    Cell: ({ row }) => {
      const [isExpanded, setIsExpanded] = React.useState(false);

      const toggleExpanded = () => {
        setIsExpanded((prev) => !prev);
      };

      const content = getNotificationBody(row.original);

      return (
        <div className="flex max-w-lg flex-col items-start gap-1 text-start text-sm text-gray-600 dark:text-gray-400">
          <p title={content} className="whitespace-pre-line leading-6">
            {isExpanded ? content : content.slice(0, 50)}
            {content.length > 50 && !isExpanded && "..."}
          </p>
          {content.length > 50 && (
            <button
              type="button"
              onClick={toggleExpanded}
              className="text-xs font-semibold text-blueSecondary underline"
            >
              {isExpanded ? "إظهار أقل" : "إظهار المزيد"}
            </button>
          )}
        </div>
      );
    },
  },
  {
    Header: "نوع الإشعار",
    accessor: "notificationType",
    Cell: ({ row }) => (
      <span>{getNotificationTypeLabel(row.values.notificationType)}</span>
    ),
  },
  {
    Header: "تاريخ الإنشاء",
    accessor: "createdAt",
    Cell: ({ row }) => {
      const date = new Date(row.values.createdAt).toLocaleString("ar-EG", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return <span>{date}</span>;
    },
  },
  {
    Header: "الإجراء",
    id: "route",
    Cell: ({ row }) => (
      <Link
        to={getNotificationRoute(row.original)}
        className="inline-flex whitespace-nowrap rounded-md bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100"
      >
        فتح
      </Link>
    ),
  },
];

export { AdminNotificationsColumn };
